var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisualbreakBgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 434,
    viewBox: "0 0 393 434",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.0921,
    y1: -13.0921,
    x2: 109.02,
    y2: -13.0921,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 297.906 289.741)",
    stroke: "#8EC2FF",
    strokeWidth: 26.1842,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8.47136,
    y1: -8.47136,
    x2: 113.641,
    y2: -8.47136,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 109.068 252.853)",
    stroke: "#8EC2FF",
    strokeWidth: 16.9427,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 11.5519,
    y1: -11.5519,
    x2: 55.2227,
    y2: -11.5519,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 417.815 255.858)",
    stroke: "#8EC2FF",
    strokeWidth: 23.1037,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 7.31617,
    y1: -7.31617,
    x2: 127.388,
    y2: -7.31617,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 444.138 173.759)",
    stroke: "#8EC2FF",
    strokeWidth: 14.6323,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 4.62074,
    y1: -4.62074,
    x2: 185.425,
    y2: -4.62074,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 108.663 392.088)",
    stroke: "#8EC2FF",
    strokeWidth: 9.24148,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 461.289,
    y1: 313.333,
    x2: 335.5,
    y2: 269.631,
    stroke: "#8EC2FF",
    strokeWidth: 9.24148,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 0.385062,
    y1: -0.385062,
    x2: 231.41,
    y2: -0.385062,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 289.177 195.797)",
    stroke: "#8EC2FF",
    strokeWidth: 0.770124,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 0.385062,
    y1: -0.385062,
    x2: 231.41,
    y2: -0.385062,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 467.365 409.736)",
    stroke: "#8EC2FF",
    strokeWidth: 0.770124,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 0.385062,
    y1: -0.385062,
    x2: 191.862,
    y2: -0.385062,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 530.028 232.123)",
    stroke: "#8EC2FF",
    strokeWidth: 0.770123,
    strokeLinecap: "round"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 15.4025,
    y1: -15.4025,
    x2: 71.8099,
    y2: -15.4025,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 207.84 348.369)",
    stroke: "#8EC2FF",
    strokeWidth: 30.8049,
    strokeLinecap: "round"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 10.0116,
    y1: -10.0116,
    x2: 132.193,
    y2: -10.0116,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 332.404 487.313)",
    stroke: "#8EC2FF",
    strokeWidth: 20.0232,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 21.1784,
    y1: -21.1784,
    x2: 38.9525,
    y2: -21.1784,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 383.999 456.364)",
    stroke: "#8EC2FF",
    strokeWidth: 42.3568,
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 13.4772,
    y1: -13.4772,
    x2: 108.646,
    y2: -13.4772,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 86.0266 94.79)",
    stroke: "#8EC2FF",
    strokeWidth: 26.9543,
    strokeLinecap: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 19.2531,
    y1: -19.2531,
    x2: 52.9189,
    y2: -19.2531,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 268.638 161.511)",
    stroke: "#8EC2FF",
    strokeWidth: 38.5062,
    strokeLinecap: "round"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 12.322,
    y1: -12.322,
    x2: 83.058,
    y2: -12.322,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 26.7378 182.205)",
    stroke: "#8EC2FF",
    strokeWidth: 24.6439,
    strokeLinecap: "round"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 0.770123,
    y1: -0.770123,
    x2: 282.978,
    y2: -0.770123,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 162.786 365.572)",
    stroke: "#8EC2FF",
    strokeWidth: 1.54025,
    strokeLinecap: "round"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 3.08049,
    y1: -3.08049,
    x2: 201.345,
    y2: -3.08049,
    transform: "matrix(-0.942613 -0.333888 -0.333888 0.942613 148.686 172.895)",
    stroke: "#8EC2FF",
    strokeWidth: 6.16099,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualbreakBgMobile);
export default __webpack_public_path__ + "static/media/visualbreak_bg_mobile.bbd76f52a1cf20976b02d18b84b99133.svg";
export { ForwardRef as ReactComponent };